<template>
  <div class="maintanance">
    <main>
      <div id="fade-in">
        <img class="Pinzi-BG" src="https://newkidsontheblog.de/assets/Pinzi-BG.svg" alt="" />
        <img class="Pinzi-Head" src="https://newkidsontheblog.de/assets/Pinzi-Head.svg" alt="" />
        <img class="Pinzi-Bubble" src="https://newkidsontheblog.de/assets/Pinzi-Bubble.svg" alt="" />
      </div>
      <div class="infobox">
        <a href="#">
          <img src="/infobox-itf.png" alt="" />
        </a>
      </div>
    </main>
  </div>
</template>

<script>
import { defineComponent, computed, reactive } from 'vue'

import { useHead } from '@vueuse/head'

export default defineComponent({
  components: { },

  setup() {
    const siteData = reactive({
      title: `ITF Bruchköbel - ITF Head Cup`,
      description: `Willkommen auf der offiziellen Website des HEAD Cup Bruchköbel operated by Achat Hotels!`,
      thumbnail: '',
      lang: '',
      url: '',
      locale: 'en',
      locale_alternate: 'de',
      ld_json_webpage: '',
      ld_json_website: ''
    })

    useHead({
      title: computed(() => siteData.title),
      htmlAttrs: {
        lang: computed(() => siteData.lang),
      },
      meta: [
        {
          name: `description`,
          content: computed(() => siteData.description),
        },
        // Twitter
        { name: 'twitter:title', content: computed(() => siteData.title) },
        { name: 'twitter:description', content: computed(() => siteData.description) },
        { name: 'twitter:image', content: computed(() => siteData.thumbnail) },
        { name: 'twitter:url', content: computed(() => siteData.url) },
        { name: 'twitter:domain', content: location.origin },
        { name: 'twitter:card', content: 'summary_large_image' },
        // Google+ / Schema.org
        { itemprop: 'name', content: computed(() => siteData.title) },
        { itemprop: 'description', content: computed(() => siteData.description) },
        // Facebook / Open Graph
        { property: 'og:url', content: computed(() => siteData.url) },
        { property: 'og:type', content: 'website' },
        { property: 'og:title', content: computed(() => siteData.title) },
        { property: 'og:description', content: computed(() => siteData.description) },
        { property: 'og:image', content: computed(() => siteData.thumbnail) },

        { property: 'og:locale', content: computed(() => siteData.locale) },
        { property: 'og:locale:alternate', content: computed(() => siteData.locale_alternate) },
      ],
      link: [
        { rel: 'canonical', href: computed(() => siteData.url) , id: 'canonical' },
      ],
      script: [
        {
          type: 'application/ld+json',
          children : computed(() => siteData.ld_json_webpage)
        },
        {
          type: 'application/ld+json',
          children : computed(() => siteData.ld_json_website)
        }
      ]
    })

    return {
      siteData
    }
  },

  data() {
    return {
      highlights: [],
      news: [],

      logo: null,
    };
  },

  computed: { },

  methods: {

  },

  mounted() {
	  document.getElementById("fade-in").className = "fade-me";
  },
})
</script>

<style lang="scss">
  .maintanance {
    width: 100%;
    height: 100vh;

    @-webkit-keyframes bg {
      5% {
        opacity: 1;
      }
      50% {
        -webkit-transform: scale(1.5);
                transform: scale(1.5);
      }
      70% {
        -webkit-transform: scale(1);
                transform: scale(1);
      }
      80% {
        -webkit-transform: scale(1.2);
                transform: scale(1.2);
      }
      100% {
        -webkit-transform: scale(1);
                transform: scale(1);
      }
    }

    @keyframes bg {
      5% {
        opacity: 1;
      }
      50% {
        -webkit-transform: scale(1.5);
                transform: scale(1.5);
      }
      70% {
        -webkit-transform: scale(1);
                transform: scale(1);
      }
      80% {
        -webkit-transform: scale(1.2);
                transform: scale(1.2);
      }
      100% {
        -webkit-transform: scale(1);
                transform: scale(1);
      }
    }

    @-webkit-keyframes float {
      0% {
        -webkit-transform: translatey(0px);
                transform: translatey(0px);
      }
      50% {
        -webkit-transform: translatey(15px);
                transform: translatey(15px);
      }
      100% {
        -webkit-transform: translatey(0px);
                transform: translatey(0px);
      }
    }

    @keyframes float {
      0% {
        -webkit-transform: translatey(0px);
                transform: translatey(0px);
      }
      50% {
        -webkit-transform: translatey(15px);
                transform: translatey(15px);
      }
      100% {
        -webkit-transform: translatey(0px);
                transform: translatey(0px);
      }
    }

    @-webkit-keyframes infobox {
      from {
        opacity: 0;
        -webkit-transform: translateY(160px);
                transform: translateY(160px);
      }
      to {
        opacity: 1;
        -webkit-transform: translateY(0px);
                transform: translateY(0px);
      }
    }

    @keyframes infobox {
      from {
        opacity: 0;
        -webkit-transform: translateY(160px);
                transform: translateY(160px);
      }
      to {
        opacity: 1;
        -webkit-transform: translateY(0px);
                transform: translateY(0px);
      }
    }

    body {
      margin: 0;
      height: 100vh;
      overflow: hidden;
    }
    main {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      width: 100%;
      height: 100%;
      -webkit-box-align: center;
          -ms-flex-align: center;
              align-items: center;
      //justify-content: center;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
          -ms-flex-direction: column;
              flex-direction: column;
    }
    #fade-in {
      width: 80vh;
      height: 50%;
      max-width: calc(100vw - 2 * 16px);
      opacity: 0;
      -webkit-transition: all ease-in-out 2s;
      -o-transition: all ease-in-out 2s;
      transition: all ease-in-out 2s;
      -webkit-transform: scale(3);
      -ms-transform: scale(3);
          transform: scale(3);
      position: relative;
      margin: 35px;
    }

    #fade-in.fade-me {
      opacity: 1;
      -webkit-transform: scale(1);
      -ms-transform: scale(1);
          transform: scale(1);
    }

    #fade-in img {
      position: absolute;
      opacity: 0;
      &.Pinzi-BG {
        -webkit-animation: bg 1.2s 3s ease-in-out forwards;
                animation: bg 1.2s 3s ease-in-out forwards;
        width: 50%;
        bottom: 0;
        left: 25%;
        opacity: 0;
        -webkit-transform: scale(0);
            -ms-transform: scale(0);
                transform: scale(0);
      }
      &.Pinzi-Head {
        -webkit-transition: all ease-in-out 0.5s 0.75s;
        -o-transition: all ease-in-out 0.5s 0.75s;
        transition: all ease-in-out 0.5s 0.75s;
        width: 34%;
        left: 31%;
        -webkit-animation: float 2.4s cubic-bezier(0.65, 0.05, 0.36, 1) 3.2s infinite;
                animation: float 2.4s cubic-bezier(0.65, 0.05, 0.36, 1) 3.2s infinite;
        bottom: 7.5%;
      }
      &.Pinzi-Bubble {
        -webkit-transition: opacity ease-in-out 0.6s 2.5s, -webkit-transform ease-in-out 0.75s 3.5s;
        transition: opacity ease-in-out 0.6s 2.5s, -webkit-transform ease-in-out 0.75s 3.5s;
        -o-transition: opacity ease-in-out 0.6s 2.5s, transform ease-in-out 0.75s 3.5s;
        transition: opacity ease-in-out 0.6s 2.5s, transform ease-in-out 0.75s 3.5s;
        transition: opacity ease-in-out 0.6s 2.5s, transform ease-in-out 0.75s 3.5s, -webkit-transform ease-in-out 0.75s 3.5s;
        -webkit-transform: rotate(0deg);
            -ms-transform: rotate(0deg);
                transform: rotate(0deg);
        width: 20%;
        right: 13%;
        bottom: 25%;
      }
    }

    #fade-in.fade-me img {
      opacity: 1;
      &.Pinzi-Bubble {
        -webkit-transform: rotate(3deg);
            -ms-transform: rotate(3deg);
                transform: rotate(3deg);
      }
    }

    .infobox {
      -webkit-animation: infobox 3.5s cubic-bezier(0.77, 0, 0.2, 1);
              animation: infobox 3.5s cubic-bezier(0.77, 0, 0.2, 1);
      img {
        max-width: calc(100vw - 2 * 1.6rem);
      }
    }

  }
</style>
